import { render, staticRenderFns } from "./AppointmentRequests.vue?vue&type=template&id=2f3bd557"
import script from "./AppointmentRequests.vue?vue&type=script&lang=js"
export * from "./AppointmentRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f3bd557')) {
      api.createRecord('2f3bd557', component.options)
    } else {
      api.reload('2f3bd557', component.options)
    }
    module.hot.accept("./AppointmentRequests.vue?vue&type=template&id=2f3bd557", function () {
      api.rerender('2f3bd557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/appointment/AppointmentRequests.vue"
export default component.exports